"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var AuthActions = _interopRequireWildcard(require("../../actions"));
var events = _interopRequireWildcard(require("../../constants/events"));
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var LegacyAuthProvider = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LegacyAuthProvider, _Component);
  var _super = _createSuper(LegacyAuthProvider);
  function LegacyAuthProvider(props) {
    var _this;
    (0, _classCallCheck2.default)(this, LegacyAuthProvider);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "instance", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getChildContext", function () {
      return {
        auth: {
          authManager: _this.instance
        }
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentWillUnmount", function () {
      // remove event handlers from AuthManager instance (Auth0Wrapper)
      if (!_lodash.default.isUndefined(_this.instance)) {
        _this.instance.removeListener(events.LOADING_USER, _this.onLoadUser);
        _this.instance.removeListener(events.USER_FOUND, _this.onUserFound);
        _this.instance.removeListener(events.LOAD_USER_ERROR, _this.onLoadUserError);
        _this.instance.removeListener(events.USER_SIGNED_OUT, _this.onUserSignedOut);
        _this.instance.removeListener(events.SESSION_TERMINATED, _this.onSessionTerminated);
        _this.instance = undefined;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLoadUser", function () {
      var dispatch = _this.props.store.dispatch;
      dispatch(AuthActions.loadingUser());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUserFound", function (user) {
      var dispatch = _this.props.store.dispatch;
      dispatch(AuthActions.userFound(user));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLoadUserError", function () {
      var dispatch = _this.props.store.dispatch;
      dispatch(AuthActions.loadUserError());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUserSignedOut", function () {
      var dispatch = _this.props.store.dispatch;
      dispatch(AuthActions.userSignedOut());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSessionTerminated", function () {
      var dispatch = _this.props.store.dispatch;
      dispatch(AuthActions.sessionTerminated()); // this.instance.signOut(`${this.instance.config.logoutPath}`);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var children = _this.props.children;
      return _react.default.Children.only(children);
    });
    var authManagerInstance = props.authManagerInstance;
    if (!_lodash.default.isUndefined(authManagerInstance)) {
      _this.instance = authManagerInstance; // register event handlers with AuthManager instance (Auth0Wrapper)

      _this.instance.on(events.LOADING_USER, _this.onLoadUser);
      _this.instance.on(events.USER_FOUND, _this.onUserFound);
      _this.instance.on(events.LOAD_USER_ERROR, _this.onLoadUserError);
      _this.instance.on(events.USER_SIGNED_OUT, _this.onUserSignedOut);
      _this.instance.on(events.SESSION_TERMINATED, _this.onSessionTerminated);
    }
    return _this;
  }
  return LegacyAuthProvider;
}(_react.Component);
exports.default = LegacyAuthProvider;
(0, _defineProperty2.default)(LegacyAuthProvider, "propTypes", {
  authManagerInstance: _propTypes.default.shape({}).isRequired,
  store: _propTypes.default.shape({
    dispatch: _propTypes.default.func.isRequired
  }).isRequired,
  children: _propTypes.default.node
});
(0, _defineProperty2.default)(LegacyAuthProvider, "defaultProps", {
  children: /*#__PURE__*/_react.default.createElement("div", null)
});
(0, _defineProperty2.default)(LegacyAuthProvider, "childContextTypes", {
  auth: _propTypes.default.shape({
    authManager: _propTypes.default.shape({}).isRequired
  }).isRequired
});